import { useTranslation } from 'react-i18next';
import Box from 'shell/components/Box';
import Button from 'shell/components/Button';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';
import { formatVideoTime } from 'utils/videoGrading';
import { EvidenceStatusTag, SpeakerTag } from './EvidenceTags';

const VideoEvidenceCard = ({ evidence, fileName, onSeek, onSelectFile }) => {
    const { t } = useTranslation('assignment');
    const hasTime =
        Number.isFinite(evidence.start) &&
        evidence.start >= 0 &&
        Number.isFinite(evidence.end) &&
        evidence.end > evidence.start;
    const time = hasTime ? `${formatVideoTime(evidence.start)}–${formatVideoTime(evidence.end)}` : '';
    return (
        <Stack
            spacing={3}
            sx={(theme) => ({
                p: 3,
                border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
                borderRadius: '16px',
                background: theme.palette.ensightful.shades[0],
            })}
        >
            <Stack direction={'row'} alignItems={'center'} useFlexGap flexWrap={'wrap'} spacing={2}>
                {hasTime && onSeek ? (
                    <Button
                        variant={'borderless'}
                        sx={{ p: 0 }}
                        aria-label={t('video-grading.play-range', 'Play evidence from {{time}}', { time })}
                        onClick={(event) => {
                            event.stopPropagation();
                            onSeek(evidence);
                        }}
                    >
                        {time}
                    </Button>
                ) : (
                    <Text variant={'p3'} color={'light'}>
                        {time || t('video-grading.time-unavailable', 'Time unavailable')}
                    </Text>
                )}
                <SpeakerTag label={evidence.speakerLabel} />
                <Box sx={{ ml: 'auto' }}>
                    <EvidenceStatusTag status={evidence.status} />
                </Box>
            </Stack>
            {fileName && onSelectFile ? (
                <Button
                    variant={'borderless'}
                    sx={{ p: 0, alignSelf: 'flex-start', textAlign: 'left', overflowWrap: 'anywhere' }}
                    aria-label={t('video-grading.view-file', 'View evidence file {{name}}', { name: fileName })}
                    onClick={(event) => {
                        event.stopPropagation();
                        onSelectFile();
                    }}
                >
                    {fileName}
                </Button>
            ) : fileName ? (
                <Text variant={'p3'} color={'light'}>
                    {fileName}
                </Text>
            ) : null}
            {evidence.quote && (
                <Text
                    component={'blockquote'}
                    variant={'p3'}
                    sx={(theme) => ({
                        m: 0,
                        pl: 2,
                        borderLeft: `2px solid ${theme.palette.ensightful.neutral[300]}`,
                        fontStyle: 'italic',
                    })}
                >
                    {evidence.quote}
                </Text>
            )}
            {evidence.explanation && <Text variant={'p3'}>{evidence.explanation}</Text>}
        </Stack>
    );
};

export default VideoEvidenceCard;
